export interface AnalyticsQuest {
  id: string;
  name: string;
}

export interface BillingData {
  uniqueUsers: number;
  snapshotDate: string;
  orgId: number;
  orgName: string;
  totalLocations: number;
  totalNonDeletedLocations: number;
  liveLocations: number;
  fmsBreakdown: any;
  sitelink: number;
  ssmCloud: number;
  ssm: number;
}
export enum AnalyticsEventType {
  USER_SESSION_START = "session_start",
  USER_NEW_USER_CREATED = "new_user_created",
  USER_RETURNED = "user_returned",
  USER_CONVERSATION_TAKEN_OVER = "conversation_taken_over", // This still needs some work. We don't have this centralized.

  // Contact Center V3 events
  CC_ESCALATION_ACCEPTED = "cc_escalation_accepted",
  CC_ESCALATION_REJECTED = "cc_escalation_rejected",
  CC_ESCALATION_COMPLETED = "cc_escalation_completed",
  CC_ESCALATION_TRANSFERRED = "cc_escalation_transferred",
  CC_AGENT_MESSAGE_SENT = "cc_agent_message_sent",
  CC_PROACTIVE_TAKEOVER = "cc_proactive_takeover",

  // user_returned:0,
  // new_user_created:0,
  // conversation_taken_over:0,

  MESSAGE = "message",

  NLP_HANDLED = "handled",
  NLP_UNHANDLED = "unhandled",

  TRAINING_INTENT_LABELED = "intent_labeled",

  EXPERIMENT_STARTED = "started",
  EXPERIMENT_FINISHED = "finished",
  EXPERIMENT_UNSTARTED_FINISH = "unstarted_finish"
}
